// adapted from https://unpkg.com/fbjs@0.8.17/lib/performance.js

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

module.exports = window.performance || {};



//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5065/js/vendor/performance.js
// module id = 339
// module chunks = 209 210 211 212